import { normalizeUiMessage } from '../../utils/message-normalizer';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit {

  constructor(private router: Router, public alertController: AlertController, public toastController: ToastController) { }

  isUserLoggedIn: any;
  ngAfterViewInit() {
    this.isUserLoggedIn = JSON.parse(localStorage.getItem('loggedInUser'));
    // const url = urlPath[urlPath.length - 1].path;
    
  }

  login() {
    let str = this.router.url.replace(/\//g, '')
    console.log('url is===', str)
    localStorage.setItem("isUserNavigatedFromCheckout", str);
    this.router.navigateByUrl('/login');
  }

  async presentTwoBtnAlertLogout() {
    const alert = await this.alertController.create({
      header: '',
      message: "Are you sure you want to logout?",
      buttons: [
        {
          text: 'No',
          cssClass:'alert-button-confirm',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Yes',
          cssClass:'alert-button-confirm',
          role: 'Yes',
          handler: () => {

            this.isUserLoggedIn = false;
            localStorage.setItem('isUserLoggedIn', null);
            localStorage.setItem('loggedInUser', null);
            this.presentToast("Logout Successfully")
          }
        }
      ]
    });

    await alert.present();
  }
  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: normalizeUiMessage(msg),
      duration: 2000,
      position: 'middle',
      cssClass: "toast-mess"
    });
    toast.present();
  }

}
